import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import { ActivityBadge } from '../../atoms/activityBadge/ActivityBadge'
import { BodyText } from '../../atoms/bodyText/BodyText'
import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { HEALTH_PLAN_INFO_MESSAGES } from '../../pages/healthPlanInformation/healthPlanInfoMessages'
import { BodyTextSize } from '../../styles/typeStyles'
import { Flex1View } from '../../templates/content/CommonViews'

const HealthPlanCardUploadTitleHeaderContainer = styled(Flex1View)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

export interface HealthPlanCardUploadHeaderTitleProps {
  hideOptionalBadge?: boolean
  isTeenDependent?: boolean
}

export const HealthPlanCardUploadHeaderTitle: FunctionComponent<HealthPlanCardUploadHeaderTitleProps> = ({
  hideOptionalBadge = false,
  isTeenDependent = false,
}) => {
  const { formatMessage } = useIntl()

  return (
    <HealthPlanCardUploadTitleHeaderContainer>
      <BodyText
        text={formatMessage(HEALTH_PLAN_INFO_MESSAGES.uploadHealthInsuranceCard, { isTeenDependent })}
        size={BodyTextSize.DEFAULT}
      />
      {!hideOptionalBadge && (
        <ActivityBadge
          text={formatMessage(HEALTH_PLAN_INFO_MESSAGES.uploadOptional)}
          variant={BadgeVariant.NEUTRAL}
          shape={BadgeShape.RECT}
        />
      )}
    </HealthPlanCardUploadTitleHeaderContainer>
  )
}

export default HealthPlanCardUploadHeaderTitle
